__turbopack_context__.v({
  "root": "BaseRadio-module__iRGaSW__root",
});
